import { Loader2 } from "lucide-react";

export function RouteFallback() {
  return (
    <div className="flex h-[40vh] items-center justify-center gap-2 text-[var(--color-text-muted)]">
      <Loader2 size={16} className="animate-spin" />
      <span className="text-[12px] uppercase tracking-widest">Cargando...</span>
    </div>
  );
}
